import React, { useState, useEffect } from 'react';
import Icon from '../AppIcon';

const ResultsSectionNav = ({ activeSection, onSectionChange }) => {
  const [isFloatingMenuOpen, setIsFloatingMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const sections = [
    {
      id: 'planetary-positions',
      label: 'ตำแหน่งดาวเคราะห์',
      labelEn: 'Planetary Positions',
      icon: 'Globe',
    },
    {
      id: 'house-cusps',
      label: 'จุดเริ่มต้นบ้าน',
      labelEn: 'House Cusps',
      icon: 'Home',
    },
    {
      id: 'midpoints',
      label: 'จุดกึ่งกลาง',
      labelEn: 'Midpoints',
      icon: 'GitBranch',
    },
    {
      id: 'aspects',
      label: 'มุมระหว่างดาว',
      labelEn: 'Aspects',
      icon: 'Triangle',
    },
    {
      id: 'uranian-points',
      label: 'จุดยูเรเนียน',
      labelEn: 'Uranian Points',
      icon: 'Sparkles',
    },
    {
      id: 'dignities',
      label: 'ศักดิ์ศรีดาว',
      labelEn: 'Dignities',
      icon: 'Award',
    },
  ];

  const handleSectionClick = (sectionId) => {
    onSectionChange(sectionId);
    setIsFloatingMenuOpen(false);
    
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element?.getBoundingClientRect()?.top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  if (isMobile) {
    return (
      <>
        <button
          onClick={() => setIsFloatingMenuOpen(!isFloatingMenuOpen)}
          className="fixed bottom-6 right-6 z-90 w-14 h-14 bg-primary text-primary-foreground rounded-full shadow-brand-xl flex items-center justify-center transition-smooth hover:scale-105 active:scale-95"
          aria-label="Toggle sections menu"
        >
          <Icon name={isFloatingMenuOpen ? 'X' : 'Menu'} size={24} />
        </button>
        {isFloatingMenuOpen && (
          <div className="fixed inset-0 z-80 bg-background">
            <div className="h-full overflow-y-auto p-6 pt-20">
              <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
                ส่วนต่างๆ ของแผนภูมิ
              </h3>
              <div className="space-y-2">
                {sections?.map((section) => (
                  <button
                    key={section?.id}
                    onClick={() => handleSectionClick(section?.id)}
                    className={`
                      w-full flex items-center px-4 py-3 rounded-lg text-sm font-medium transition-smooth
                      ${
                        activeSection === section?.id
                          ? 'bg-primary text-primary-foreground shadow-brand'
                          : 'bg-card text-foreground hover:bg-muted'
                      }
                    `}
                  >
                    <Icon 
                      name={section?.icon} 
                      size={20} 
                      className="mr-3"
                      color={activeSection === section?.id ? 'currentColor' : 'var(--color-muted-foreground)'}
                    />
                    <div className="flex flex-col items-start">
                      <span>{section?.label}</span>
                      <span className="text-xs opacity-75">{section?.labelEn}</span>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}
      </>
    );
  }

  return (
    <nav className="sticky top-20 z-90 bg-card border border-border rounded-lg p-4 shadow-brand-md">
      <h3 className="text-sm font-caption font-medium text-muted-foreground uppercase tracking-wide mb-4">
        ส่วนต่างๆ ของแผนภูมิ
      </h3>
      <div className="space-y-1">
        {sections?.map((section) => (
          <button
            key={section?.id}
            onClick={() => handleSectionClick(section?.id)}
            className={`
              w-full flex items-center px-3 py-2 rounded-md text-sm font-medium transition-smooth
              ${
                activeSection === section?.id
                  ? 'bg-primary text-primary-foreground shadow-brand'
                  : 'text-foreground hover:bg-muted hover:translate-y-[-1px]'
              }
            `}
          >
            <Icon 
              name={section?.icon} 
              size={18} 
              className="mr-3"
              color={activeSection === section?.id ? 'currentColor' : 'var(--color-muted-foreground)'}
            />
            <div className="flex flex-col items-start">
              <span className="text-left">{section?.label}</span>
              <span className="text-xs opacity-75 text-left">{section?.labelEn}</span>
            </div>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default ResultsSectionNav;